import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { FuseSharedModule } from '@fuse/shared.module';

import { ReglaBaseComponent } from './regla-base.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatTableModule } from '@angular/material/table';
import { MatSelectModule } from '@angular/material/select';
import { DialogBoxComponent } from './dialog/dialog-box.component';
//import { MandatoDialogBoxComponent } from './dialog/mandato-dialog-box.component';
import { DialogBoxTreeComponent } from './dialog/dialog-box-tree.component';
import { DialogBoxAddNodeComponent } from './dialog/dialog-box-add-node.component';
import { DialogBoxChangeFatherComponent } from './dialog/dialog-box-change-father.component';
import { DialogBoxChangeTreeComponent } from './dialog/dialog-box-change-tree.component';
import { DialogBoxPrintComponentReglaBase } from './dialog/dialog-print-box.component';

import {MatChipsModule} from '@angular/material/chips';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import {MatTreeModule} from '@angular/material/tree';
import {MatIconModule} from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import {MatSnackBarModule} from '@angular/material/snack-bar';
import { MatPaginatorModule } from '@angular/material/paginator';




@NgModule({
    declarations: [
        ReglaBaseComponent,
        DialogBoxComponent,
        DialogBoxTreeComponent,
        DialogBoxAddNodeComponent,
        DialogBoxChangeFatherComponent,
        DialogBoxChangeTreeComponent,
        DialogBoxPrintComponentReglaBase
    ],
    imports     : [
        BrowserAnimationsModule,
        FormsModule,
        MatTableModule,
        MatDialogModule,
        MatFormFieldModule,
        MatInputModule,
        MatButtonModule,
        MatInputModule,
        MatSelectModule,
        MatChipsModule,
        FuseSharedModule,
        MatAutocompleteModule,
        MatTreeModule,
        TranslateModule,
        MatIconModule,
        MatSnackBarModule,
        MatPaginatorModule
    ],
    entryComponents: [
        DialogBoxComponent,
        DialogBoxTreeComponent,
        DialogBoxAddNodeComponent,
        DialogBoxChangeFatherComponent,
        DialogBoxChangeTreeComponent,
        DialogBoxPrintComponentReglaBase
    ]
})
export class ReglaBaseModule
{
}
